
import React from 'react';
import { Calendar } from 'lucide-react';
import { CardTitle } from '@/components/ui/card';

interface MaintenanceHeaderProps {
  title: string;
  nextMaintenance?: string;
}

const MaintenanceHeader: React.FC<MaintenanceHeaderProps> = ({ title, nextMaintenance }) => {
  return (
    <div className="flex justify-between items-center">
      <CardTitle>{title}</CardTitle>
      {nextMaintenance && (
        <div className="flex items-center text-sm text-muted-foreground">
          <Calendar className="h-4 w-4 mr-1" />
          <span>Next scheduled: {nextMaintenance}</span>
        </div>
      )}
    </div>
  );
};

export default MaintenanceHeader;
